import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChipsComponent } from './pages/chips/chips.component';
import { ExpansionComponent } from './pages/expansion/expansion.component';
import { GridListComponent } from './pages/grid-list/grid-list.component';
import { MenuComponent } from './pages/menu/menu.component';
import { ProgressSnipperComponent } from './pages/progress-snipper/progress-snipper.component';
import { ProgressComponent } from './pages/progress/progress.component';
import { SlideToggleComponent } from './pages/slide-toggle/slide-toggle.component';
import { SliderComponent } from './pages/slider/slider.component';
import { SnackbarComponent } from './pages/snackbar/snackbar.component';
import { TabsComponent } from './pages/tabs/tabs.component';
import { ToolbarComponent } from './pages/toolbar/toolbar.component';
import { TooltipsComponent } from './pages/tooltips/tooltips.component';
import { ProductComponent } from './dashboard/dashboard-admin/dashboard-admin-components/product/product.component';
import { FullComponent } from './layouts/full/full.component';
import {BlankComponent} from "./layouts/blank/blank.component";
import {AuthComponent} from "./authentication/auth.component";
import {SsoCallbackComponent} from "./authentication/sso-callback/sso-callback.component";
import {SchoolProgramComponent} from "./pages/school-program/school-program.component";
import {ActivityComponent} from "./pages/activity/activity.component";
import { OnlineRegistrationComponent } from './pages/online-registration/online-registration.component';
import { RegistrationApproverComponent } from './pages/registration-approver/registration-approver.component';
import { AttendanceComponent } from './pages/attendance/attendance.component';
import { AttendanceListComponent } from './pages/attendance-list/attendance-list.component';
import { CoachComponent } from './pages/coach/coach.component';
import { ScoringComponent } from './pages/scoring/scoring.component';
import { AuthGuard } from 'src/shared/guard/auth.guard';
import { BlockedComponent } from './blocked/blocked/blocked.component';
import { TaskGuard } from 'src/shared/guard/task.guard';
import { ServerSelectComponent } from './server-select/server-select.component';
import { ActivityApproverComponent } from './pages/activity-approver/activity-approver.component';
import { RegistrationPaymentComponent } from './pages/registration-payment/registration-payment.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ApproverSetupComponent } from './pages/approver-setup/approver-setup.component';
import { PeriodSetupComponent } from './pages/period-setup/period-setup.component';
import { PaymentVaComponent } from './pages/payment-va/payment-va.component';
import { PaymentStudentComponent } from './pages/payment-student/payment-student.component';
import { ReportUnregisteredComponent } from './pages/report-unregistered/report-unregistered.component';
import { ReportRegisteredComponent } from './pages/report-registered/report-registered.component';
import { RulesComponent } from './pages/rules/rules.component';

const routes: Routes = [
  {
    path:"layout",
    canActivate: [AuthGuard],
    component:FullComponent,
    children: [
      {path:"", redirectTo:"dashboard", pathMatch:"full"},
      {path:"dashboard", loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard], data: {task: 'SCHOOL_PROGRAM_DASHBOARD_VIEW'}},
      {path:"school-program", component:SchoolProgramComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_VIEW'}},
      {path:"rule-settings/rules", component: RulesComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_RULE_VIEW'}},
      {path:"rule-settings/global-rules", loadChildren: () => import('./pages/school-program-rules/school-program-rules.module').then(m => m.SchoolProgramRulesModule), canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_RULE_VIEW'}},
      {path:"activity", loadChildren: () => import('./pages/activity/activity.module').then(m => m.ActivityModule), canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_ACTIVITY_VIEW'}},
      {path:"online-registration", component:OnlineRegistrationComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_VIEW'}},
      {path:"registration-approver", component:RegistrationApproverComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_APPROVER_VIEW'}},
      {path:"attendance", component:AttendanceComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_ATTENDANCE_VIEW'}},
      {path:"attendance/attendance-list/:id/:period", component:AttendanceListComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_ATTENDANCE_VIEW'}},
      {path:"coach", loadChildren: () => import('./pages/coach/coach.module').then(m => m.CoachModule), canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_COACH_VIEW'}},
      {path:"scoring", component:ScoringComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_SCORING_VIEW'}},
      {path:"activity-approver", component:ActivityApproverComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_ACTIVITY_APPROVER_VIEW'}},
      {path:"approver-setup", component:ApproverSetupComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_APPROVER_SETUP_VIEW'}},
      {path:"period-setup", component:PeriodSetupComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_PERIOD_SETUP_VIEW'}},
      {path:"registration-payment", component:RegistrationPaymentComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_VIEW'}},
      {path:"payment-student", component:PaymentStudentComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_STUDENT_VIEW'}},
      // {path:"payment-va", component:PaymentVaComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_VA_VIEW'}},
      {path:"payment-va", loadChildren: () => import('./pages/payment-va/payment-va.module').then(m => m.PaymentVaModule), canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REGISTRATION_PAYMENT_VA_VIEW'}},
      {path:"report-unregistered", component:ReportUnregisteredComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REPORT_UNREGISTERED_VIEW'}},
      {path:"report-registered", component:ReportRegisteredComponent, canActivate: [AuthGuard, TaskGuard], data: {task: 'SCHOOL_PROGRAM_REPORT_REGISTERED_VIEW'}},
      // {path:"table", component:ProductComponent},
      // {path:"grid-list", component:GridListComponent},
      // {path:"menu", component:MenuComponent},
      // {path:"tabs", component:TabsComponent},
      // {path:"expansion", component:ExpansionComponent},
      // {path:"chips", component:ChipsComponent},
      // {path:"progress", component:ProgressComponent},
      // {path:"toolbar", component:ToolbarComponent},
      // {path:"progress-snipper", component:ProgressSnipperComponent},
      // {path:"snackbar", component:SnackbarComponent},
      // {path:"slider", component:SliderComponent},
      // {path:"slide-toggle", component:SlideToggleComponent},
      // {path:"tooltip", component:TooltipsComponent},
    ]
  },
  { path: 'unauthorized', component: BlockedComponent },
  {
    path: '',
    component: BlankComponent,
    children: [
      {path:"", redirectTo:"server-select", pathMatch:"full"},
      {path:"login", component:AuthComponent},
      {path:"sso/callback", component:SsoCallbackComponent},
      {path:"server-select", component:ServerSelectComponent},
    ],
  },
  {
    path: '**',
    redirectTo: '/layout',
  },
];

// children: [
//   {
//     path: '',
//     redirectTo: 'auth',
//     pathMatch: 'full'
//   },
//   {
//     path: 'auth',
//     loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule),
//     canActivate: [UnauthenticatedGuard]
//   },
//   {
//     path: 'dashboard-admin',
//     loadChildren: () => import('./dashboard-admin/dashboard-admin.module').then(m => m.DashboardAdminModule),
//     canActivate: [UnauthenticatedGuard]
//   },
//   {
//     path: '**',
//     redirectTo: 'client'
//   }
// ]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
